import React, { useEffect } from 'react';
import FinanceManagerDashboard from '../Finance_Manager/FinanceManagerDashboard';
import FacilityManagerDashboard from '../Facility_Manager/FacilityManagerDashboard';
import CommercialHeadDashboard from '../Commercial_Head/CommercialHeadDashboard';
import NavBarTop from '../Reusable_Components/NavBarTop';
import LeftNavBar from '../Reusable_Components/LeftNavBar';

const CeoDashboard = () => {


    return (
        <div
            className="ceo-dashboard-container"
        >
            <NavBarTop />
            <LeftNavBar />
            <div style={{ width: "100%" }}>
                <FinanceManagerDashboard />
                <FacilityManagerDashboard />
                <CommercialHeadDashboard />
            </div>
        </div>
    );
};

export default CeoDashboard;